import React from 'react';
import './BotToggle.css';

/**
 * BotToggle - Control para encender/apagar bots
 * 
 * @param {boolean} enabled - Estado actual del bot
 * @param {function} onToggle - Callback al cambiar estado
 * @param {string} botName - Nombre del bot
 * @param {boolean} loading - Estado de carga
 * @param {boolean} disabled - Deshabilitar control
 */
export default function BotToggle({ 
  enabled, 
  onToggle, 
  botName, 
  loading = false,
  disabled = false 
}) {
  const handleClick = () => {
    if (!disabled && !loading && onToggle) {
      onToggle(!enabled);
    }
  };
  
  return (
    <div className="bot-toggle">
      <div className="bot-toggle__info">
        <span className={`bot-toggle__indicator ${enabled ? 'active' : 'inactive'}`} />
        <span className="bot-toggle__name">{botName}</span>
        <span className={`bot-toggle__status ${enabled ? 'active' : 'inactive'}`}>
          {loading ? 'Processing...' : enabled ? 'Running' : 'Stopped'}
        </span>
      </div>
      
      {/* <button 
        className={`bot-toggle__button ${enabled ? 'btn-stop' : 'btn-start'}`}
        onClick={handleClick}
        disabled={disabled || loading}
      >
        {loading ? (
          <span className="spinner"></span>
        ) : (
          enabled ? 'STOP' : 'START'
        )}
      </button> */}
    </div>
  );
}
